import { getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class FooterInformation {
  private buttons: NodeListOf<HTMLElement>

  constructor() {
    this.buttons = getElements('footer-info-button')
  }

  init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.buttons.forEach((button): void => {
      button.addEventListener('click', (): void => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', (!isExpanded).toString())
      })
    })
  }
}

const footerInformation = new FooterInformation()
footerInformation.init()
